var _throttle = require('lodash/throttle');

( function( win, doc, $ ) {

    let lazyAssets = doc.querySelectorAll('[data-lazy-background]');
    let assetsLoaded = 0;

    function lazyLoadAssets() {
        // Do not perform loop if all assets have loaded
        if ( assetsLoaded < lazyAssets.length ) {
            for ( let i = 0; i < lazyAssets.length; i++ ) {
                let asset = lazyAssets[ i ];

                // Only request if asset not already loaded
                if ( ! asset.hasAttribute( 'data-lazy-loaded' ) ) {
                    let assetTop = asset.getBoundingClientRect().top - 500;
                    let lazyValue = asset.getAttribute( 'data-lazy-background' );

                    // Request once the bottom of the screen is approaching the asset
                    if ( win.innerHeight > assetTop ) {
                        asset.style['background-image'] = 'url( ' + lazyValue + ' )';
                        asset.setAttribute( 'data-lazy-loaded', 'true' );
                        asset.removeAttribute( 'data-lazy-background' );
                        assetsLoaded++;
                    }
                }
            }
        }
    }

    if ( lazyAssets.length ) {
        win.addEventListener('load', lazyLoadAssets, false);
        win.addEventListener('scroll', _throttle( lazyLoadAssets, 75 ), { passive: true });
    }

} )( window, document, jQuery );